module.exports = __webpack_public_path__ + "img/Energies_du_santerre_120X35.3e096481.png";